module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goalsWrap",
    attrs: {
      "id": "goalsWrap"
    }
  }, [(!_vm.noDataModeShow) ? _c('p', {
    staticClass: "tableTit"
  }, [_c('span', {
    staticClass: "state1"
  }), _vm._v(" "), _vm._l((_vm.goalData.header), function(elem, index) {
    return _c('span', {
      class: 'state' + (index + 2)
    }, [_vm._v(_vm._s(elem))])
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.goalData.data), function(elem, index) {
    return _c('div', {
      staticClass: "tableBody"
    }, [_c('div', {
      staticClass: "list"
    }, [_c('span', {
      staticClass: "state1"
    }, [_vm._v(_vm._s(index + 1))]), _c('span', {
      staticClass: "state2"
    }, [_c('img', {
      staticClass: "avarta goals_avarta",
      attrs: {
        "data-src": _vm.getImgSrc(elem.person_logo),
        "src": "//img-sd.allfootballapp.com/fastdfs3/M00/B5/98/ChOxM1xC37CADGDCAAANHjH55fo314.png",
        "alt": "",
        "onerror": "javascript:this.src='//img-sd.allfootballapp.com/fastdfs3/M00/B5/98/ChOxM1xC37CADGDCAAANHjH55fo314.png'"
      }
    }), _vm._v(_vm._s(elem.person_name))]), _c('span', {
      staticClass: "state3"
    }, [_vm._v(_vm._s(elem.team_name))]), _c('span', {
      staticClass: "state4"
    }, [_vm._v(_vm._s(elem.count))])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdeda4f8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/goals.vue
// module id = 671
// module chunks = 3